// 导入自己需要的组件
import { Button, Select, Option, OptionGroup, Input, Tree, Dialog, Row, Col, FormItem,Form,Checkbox,Message } from 'element-ui'
const element = {
    install: function (Vue) {
        // Vue.use(Message)
        Vue.use(Checkbox)
        Vue.use(FormItem)
        Vue.use(Form)
        Vue.use(Button)
        Vue.use(Select)
        Vue.use(Option)
        Vue.use(OptionGroup)
        Vue.use(Input)
        Vue.use(Tree)
        Vue.use(Dialog)
        Vue.use(Row)
        Vue.use(Col)

        Vue.prototype.$message = Message;
    }
}
export default element